import React from 'react';
import './hero.scss';

const Hero = () => {
    return (
        <div className={'business-education-hero'}>
            {/*<ELEMENT_01 className={'business-education-hero_element_01'}/>*/}
            <div className="wrapper">
                <div className="wrapper_top">
                    <h1>Business Education & Guidance</h1>
                    <svg className={'wrapper_top_poly-bottom'} height="77" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default Hero;
